const readEnv = (name, fallback) => process.env[name] || fallback;

export const PUBLIC_URL = readEnv(
  "REACT_APP_PUBLIC_URL",
  "https://letsdecorateapp.com"
);
export const DEV_URL = readEnv("REACT_APP_DEV_URL", "http://localhost:8100");
export const PARSE_SERVER_URL = readEnv(
  "REACT_APP_PARSE_SERVER_URL",
  "https://letsdecorate.back4app.io"
);
export const PARSE_APP_ID = readEnv(
  "REACT_APP_PARSE_APP_ID",
  "W4f2B4g4iM635LZKAdf4adf65ZWEZ2f9bMXR5x59"
);
export const PARSE_JS_ID = readEnv(
  "REACT_APP_PARSE_JS_ID",
  "qsQ7Bmfey7mwsxdLURceDSg5gxrsXYFjaA6ibjGz"
);
export const PARSE_REST_KEY = readEnv(
  "REACT_APP_PARSE_REST_KEY",
  "6eARd0rDu5jxU1XcSRPS8irv9DcSbJRCGgMAJrRo"
);
export const STRIPE_PUBLISHABLE_KEY = readEnv(
  "REACT_APP_STRIPE_PUBLISHABLE_KEY",
  "pk_live_51H71VtHX7Wjx7cAmIXiL72njVm7DrZp9axsR8Q6J1pUM7VVT6ygJ94JOr7VD603Jj0NTidcmO3y456GT5ZwCYG1c00451IiVLN"
);
